export default __webpack_public_path__ + "static/media/Technical_Architecture_Flow_Thumnail_Image.fdadad2f.png";